<template>
  <div class="l-row">
    <form-group label="Tipo de acréscimo" :columns="2">
      <input class="form-input" v-model="additionType" readonly="readonly"/>
    </form-group>

    <form-group label="Valor do acréscimo" :columns="2">
      <div class="form-flex">
        <money v-if="item.additionType ==='fixed'" class="form-input" v-bind="money" v-model="item.additionValue"
               readonly="readonly"/>
        <input v-if="item.additionType ==='percent'" class="form-input" type="number" v-model="item.additionValue"
               readonly="readonly"/>
        <span v-if="item.additionType === 'percent'" class="form-addon">%</span>
      </div>
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group label="De" :columns="2">
      <money v-model="item.from.minRange" v-bind="money" class="form-input" readonly="readonly"/>
    </form-group>

    <form-group label="Até" :columns="2">
      <money v-model="item.to.maxRange"  v-bind="money" class="form-input" readonly="readonly"/>
    </form-group>

    <div class="l-col-2@md vertical-center">
    <slot/>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { Money } from 'v-money'

  export default {
    data: () => ({
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      additionType: null
    }),
    props: {
      preset: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.additionType = 'Fixo'
      if (this.item.additionType === 'percent') {
        this.additionType = 'Percentual'
      }
    },
    components: {
      Panel,
      FormGroup,
      Money
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// AdditionItem.vue?18d51d62